// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { ApprovalsDashboard_ApproverFragmentDoc, ApprovalsDashboard_ApprovalFragmentDoc } from '../../../../fragments/circularFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ApprovalsDashboardQueryVariables = Types.Exact<{
  filter: Types.ApprovalFilter;
}>;


export type ApprovalsDashboardQuery = { __typename?: 'Query', approvals?: { __typename?: 'ApprovalPage', approvals: Array<{ __typename?: 'Approval', id: string, requestedAt?: Types.Scalars['DateTime']['input'] | null | undefined, dueOn?: Types.Scalars['Date']['input'] | null | undefined, status: { __typename?: 'ApprovalStatusDetail', code: Types.ApprovalStatus, name: string }, subject:
        | { __typename?: 'Bill', id: string, name: string, amount: number, parents: Array<
            | { __typename?: 'Commitment', id: string }
            | { __typename?: 'CommitmentChangeOrder', id: string }
          >, tradePartner: { __typename?: 'TradePartner', id: string, name: string } }
        | { __typename?: 'ChangeEvent', displayName: string, reasonDetails?: string | null | undefined, id: string, name: string, amount: number, reason: { __typename?: 'ChangeEventReason', code: string, id: string, name: string }, blueprintUrl: { __typename?: 'Url', path: string }, impactedTrades: Array<{ __typename?: 'TradePartner', id: string, name: string }> }
        | { __typename?: 'ChangeRequest', id: string, name: string, amount: number, scopes: Array<{ __typename?: 'ChangeRequestScope', id: string, target:
              | { __typename?: 'StandaloneProject', id: string, name: string }
              | { __typename?: 'Region', id: string, name: string }
              | { __typename?: 'Development', id: string, name: string }
              | { __typename?: 'Market', id: string, name: string }
              | { __typename?: 'Community', id: string, name: string }
              | { __typename?: 'Subdivision', id: string, name: string }
              | { __typename?: 'Lot', id: string, name: string }
              | { __typename?: 'Structure', id: string, name: string }
              | { __typename?: 'Unit', id: string, name: string }
             }> }
        | { __typename?: 'Invoice', id: string, name: string, amount: number, project:
            | { __typename?: 'StandaloneProject', id: string, primaryHomeowner?: { __typename?: 'Client', id: string, fullName: string } | null | undefined }
            | { __typename?: 'Region', id: string, primaryHomeowner?: { __typename?: 'Client', id: string, fullName: string } | null | undefined }
            | { __typename?: 'Market', id: string, primaryHomeowner?: { __typename?: 'Client', id: string, fullName: string } | null | undefined }
            | { __typename?: 'Community', id: string, primaryHomeowner?: { __typename?: 'Client', id: string, fullName: string } | null | undefined }
            | { __typename?: 'Subdivision', id: string, primaryHomeowner?: { __typename?: 'Client', id: string, fullName: string } | null | undefined }
            | { __typename?: 'Lot', id: string, primaryHomeowner?: { __typename?: 'Client', id: string, fullName: string } | null | undefined }
            | { __typename?: 'Structure', id: string, primaryHomeowner?: { __typename?: 'Client', id: string, fullName: string } | null | undefined }
            | { __typename?: 'Unit', id: string, primaryHomeowner?: { __typename?: 'Client', id: string, fullName: string } | null | undefined }
           }
      , requestedBy?: { __typename?: 'User', avatar: string, id: string, name: string } | null | undefined, rootProject?:
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
       | null | undefined, source?:
        | { __typename?: 'BidContractRevision', id: string, version: string, bidContract: { __typename?: 'BidContract', id: string, name: string } }
        | { __typename?: 'ItemTemplate', id: string, version: string, name: string }
        | { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string, name: string }
       | null | undefined, approvers: Array<{ __typename?: 'Approver', statusUpdatedAt?: Types.Scalars['DateTime']['input'] | null | undefined, id: string, order: number, requireSignature: boolean, approval: { __typename?: 'Approval', id: string, status: { __typename?: 'ApprovalStatusDetail', code: Types.ApprovalStatus, name: string }, subject:
            | { __typename?: 'Bill', id: string, type: { __typename?: 'BillTypeDetail', code: Types.BillType }, status: { __typename?: 'BillStatusDetail', code: Types.BillStatus } }
            | { __typename?: 'ChangeEvent' }
            | { __typename?: 'ChangeRequest' }
            | { __typename?: 'Invoice' }
           }, status: { __typename?: 'ApproverStatusDetail', code: Types.ApproverStatus, name: string }, pandaDocRecipient?: { __typename?: 'PandaDocRecipient', id: string, pandaDoc: { __typename?: 'PandaDoc', id: string, externalPandaDocId?: string | null | undefined, status: Types.PandaDocStatus } } | null | undefined, user:
          | { __typename?: 'Client', id: string, name: string }
          | { __typename?: 'InternalUser', id: string, avatar: string, name: string }
          | { __typename?: 'TradePartnerUser', id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string } }
         }> }> } | null | undefined };

export type UpdateApproversMutationVariables = Types.Exact<{
  inputs: Array<Types.SaveApproverInput> | Types.SaveApproverInput;
}>;


export type UpdateApproversMutation = { __typename?: 'Mutation', saveApprovers: { __typename?: 'SaveApproversResult', approvers: Array<{ __typename?: 'Approver', statusUpdatedAt?: Types.Scalars['DateTime']['input'] | null | undefined, id: string, order: number, requireSignature: boolean, approval: { __typename?: 'Approval', id: string, status: { __typename?: 'ApprovalStatusDetail', code: Types.ApprovalStatus, name: string }, subject:
          | { __typename?: 'Bill', id: string, type: { __typename?: 'BillTypeDetail', code: Types.BillType }, status: { __typename?: 'BillStatusDetail', code: Types.BillStatus } }
          | { __typename?: 'ChangeEvent' }
          | { __typename?: 'ChangeRequest' }
          | { __typename?: 'Invoice' }
         }, status: { __typename?: 'ApproverStatusDetail', code: Types.ApproverStatus, name: string }, pandaDocRecipient?: { __typename?: 'PandaDocRecipient', id: string, pandaDoc: { __typename?: 'PandaDoc', id: string, externalPandaDocId?: string | null | undefined, status: Types.PandaDocStatus } } | null | undefined, user:
        | { __typename?: 'Client', id: string, name: string }
        | { __typename?: 'InternalUser', id: string, avatar: string, name: string }
        | { __typename?: 'TradePartnerUser', id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string } }
       }> } };

export type CreatePandaDocSessionMutationVariables = Types.Exact<{
  input: Types.CreatePandaDocSessionInput;
}>;


export type CreatePandaDocSessionMutation = { __typename?: 'Mutation', createPandaDocSession: { __typename?: 'PandaDocSession', sessionId: string } };


export const ApprovalsDashboardDocument = gql`
    query ApprovalsDashboard($filter: ApprovalFilter!) {
  approvals(filter: $filter) {
    approvals {
      ...ApprovalsDashboard_Approval
    }
  }
}
    ${ApprovalsDashboard_ApprovalFragmentDoc}`;

/**
 * __useApprovalsDashboardQuery__
 *
 * To run a query within a React component, call `useApprovalsDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useApprovalsDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApprovalsDashboardQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useApprovalsDashboardQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ApprovalsDashboardQuery, ApprovalsDashboardQueryVariables> & ({ variables: ApprovalsDashboardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ApprovalsDashboardQuery, ApprovalsDashboardQueryVariables>(ApprovalsDashboardDocument, options);
      }
export function useApprovalsDashboardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ApprovalsDashboardQuery, ApprovalsDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ApprovalsDashboardQuery, ApprovalsDashboardQueryVariables>(ApprovalsDashboardDocument, options);
        }
// @ts-ignore
export function useApprovalsDashboardSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ApprovalsDashboardQuery, ApprovalsDashboardQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApprovalsDashboardQuery, ApprovalsDashboardQueryVariables>;
export function useApprovalsDashboardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApprovalsDashboardQuery, ApprovalsDashboardQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApprovalsDashboardQuery | undefined, ApprovalsDashboardQueryVariables>;
export function useApprovalsDashboardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApprovalsDashboardQuery, ApprovalsDashboardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ApprovalsDashboardQuery, ApprovalsDashboardQueryVariables>(ApprovalsDashboardDocument, options);
        }
export type ApprovalsDashboardQueryHookResult = ReturnType<typeof useApprovalsDashboardQuery>;
export type ApprovalsDashboardLazyQueryHookResult = ReturnType<typeof useApprovalsDashboardLazyQuery>;
export type ApprovalsDashboardSuspenseQueryHookResult = ReturnType<typeof useApprovalsDashboardSuspenseQuery>;
export type ApprovalsDashboardQueryResult = ApolloReactCommon.QueryResult<ApprovalsDashboardQuery, ApprovalsDashboardQueryVariables>;
export const UpdateApproversDocument = gql`
    mutation UpdateApprovers($inputs: [SaveApproverInput!]!) {
  saveApprovers(inputs: $inputs) {
    approvers {
      ...ApprovalsDashboard_Approver
    }
  }
}
    ${ApprovalsDashboard_ApproverFragmentDoc}`;

/**
 * __useUpdateApproversMutation__
 *
 * To run a mutation, you first call `useUpdateApproversMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApproversMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApproversMutation, { data, loading, error }] = useUpdateApproversMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateApproversMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateApproversMutation, UpdateApproversMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateApproversMutation, UpdateApproversMutationVariables>(UpdateApproversDocument, options);
      }
export type UpdateApproversMutationHookResult = ReturnType<typeof useUpdateApproversMutation>;
export type UpdateApproversMutationResult = ApolloReactCommon.MutationResult<UpdateApproversMutation>;
export const CreatePandaDocSessionDocument = gql`
    mutation CreatePandaDocSession($input: CreatePandaDocSessionInput!) {
  createPandaDocSession(input: $input) {
    sessionId
  }
}
    `;

/**
 * __useCreatePandaDocSessionMutation__
 *
 * To run a mutation, you first call `useCreatePandaDocSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePandaDocSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPandaDocSessionMutation, { data, loading, error }] = useCreatePandaDocSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePandaDocSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePandaDocSessionMutation, CreatePandaDocSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePandaDocSessionMutation, CreatePandaDocSessionMutationVariables>(CreatePandaDocSessionDocument, options);
      }
export type CreatePandaDocSessionMutationHookResult = ReturnType<typeof useCreatePandaDocSessionMutation>;
export type CreatePandaDocSessionMutationResult = ApolloReactCommon.MutationResult<CreatePandaDocSessionMutation>;